import { render, staticRenderFns } from "./AmountModifyLogs.vue?vue&type=template&id=9ceb3fd8"
import script from "./AmountModifyLogs.vue?vue&type=script&lang=js"
export * from "./AmountModifyLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports